<template>
    <div><!-- COA 上傳 -->
        <CCard class="w-100">
            <CCardHeader>
                <strong>COA</strong>
            </CCardHeader>
            <CCardBody>
                    <CForm>
                        <div class="CForminline">
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('COA.VendorName')}}：</p>                                    
                                    <input style="width: 300px;" type="text" v-if="disableCusName_input" :disabled="true" v-model="coaUploadQueryParam.customerName">                                                        
                                    <Select2 style="width: 300px;" v-if="!disableCusName_input" v-model="coaUploadQueryParam.vendorId" :options="memberListFilter()" :settings="{  multiple: false, dropdownAutoWidth : true , width: '100%' ,allowClear:true }" />
                                </div>
                                <div class="search-fluid">
                                    <p>&emsp;PO_NO：</p>
                                    <input type="text" maxlength="50" v-model="coaUploadQueryParam.poNo">
                                </div>
                            </div>                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('COA.PartNumber')}}：</p>
                                    <input type="text" maxlength="50" v-model="coaUploadQueryParam.partNumber">
                                </div>
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QuoteInfo_Vue.FactoryType')}}：</p>
                                    <div v-for="(item, key) in factoryList" :key="'factoryType_input_' + key">
                                       <input :disabled ="disableFactory" type="radio" :name="'coa_FactoryTypeOpt'" v-model="coaUploadQueryParam.factoryId" :value="item.factoryId" >{{getFactoryCaption(item.factoryId,item.factoryCaption)}}
                                    </div> 
                                </div>
                            </div>                            
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>&emsp;&emsp;{{$t('QualityInfo_Vue.Status')}}：</p>
                                    <div v-for="(item, key) in rowStatusList" :key="'coaRowStatus_input_' + key">
                                       <input type="radio" :name="'coa_RowStatusOpt'" v-model="coaUploadQueryParam.rowStatus" :value="item.rowStatusId" >{{item.rowStatusCaption}}
                                    </div> 
                                </div>
                            </div>
                            <div class="fluid">
                                <div class="search-fluid">
                                    <p>{{$t('COA.EstablishedDates')}}：</p>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="coaUploadQueryParam.createDateBegin"></date-picker> 
                                    <span>~</span>
                                    <date-picker :lang="lang" format="YYYY-MM-DD" valueType="format" v-model="coaUploadQueryParam.createDateEnd"></date-picker>
                                </div>
                            </div>
                            <div class="btn_group">                                
                                <button type="button" class="btn btn-edit mr-2" @click="coaUploadQueryEvent">{{$t('Buttons.Query')}}</button>
                                <button type="button" class="btn btn-success mr-2" @click="coaUploadExportEvent">{{$t('Buttons.ExportOrder')}}</button>
                                <router-link class="btn btn-primary" v-if="isMember" to="" @click.native="coaUploadAddNewEvent">{{$t('Buttons.AddNew')}}</router-link>
                            </div>                            
                        </div>
                    </CForm>
            </CCardBody>
        </CCard>
    </div>
</template>
<script>
import { qualityMixin } from '@/mixin/quality'
import { mapGetters } from 'vuex'
export default {
    mixins: [qualityMixin],	
    data() {
        return {            
            factoryList: this.$t('factoryQMList'), //廠別 清單
            rowStatusList: this.$t('rowStatusList'), //狀態 清單
            coaUploadQueryParam: {
                hadQuery : false,
                factoryId : '',
                customerName : '',
                createDateBegin :null,
                createDateEnd :null,
                poNo : '',
                partNumber : '',
                rowStatus : ''
            }
        }
    },
    props : {
    },
    watch: {
        "lang": function() {
            this.factoryList = this.$t('factoryQMList') //廠別 清單
            this.rowStatusList = this.$t('rowStatusList') //狀態 清單
        }
    },
    methods: {
        coaUploadQueryEvent (){            
            this.coaUploadQueryParam.hadQuery = true;
            this.$emit('coaUploadQueryEvent',this.coaUploadQueryParam);
        },                
        coaUploadExportEvent (){//匯出            
            this.$emit('coaUploadExportEvent',this.coaUploadQueryParam);
        },
        coaUploadAddNewEvent (){
            sessionStorage.setItem('coaGuid', 'new');            
            this.$router.push('coainformation');
        },
        i18n (keyStr){
            return this.$t(keyStr);
        },
    },
    computed: {
        ...mapGetters(["lang"])
    },
	mounted() {
        this.getCacheQueryParam('CoaUpload_QueryParam' , this.coaUploadQueryParam);
        const userFactoryId= this.userFactoryId;
        if(userFactoryId){
            this.coaUploadQueryParam.factoryId = userFactoryId;
        }
        if(this.isMember){
            const userInfo = this.$userInfo ;
            this.coaUploadQueryParam.vendorId = userInfo.vendorId;
            this.coaUploadQueryParam.customerName = userInfo.companyName;
        }else{
            this.initMemberQMList();
        }
        if(this.coaUploadQueryParam.hadQuery){
            this.$emit('coaUploadQueryEvent',this.coaUploadQueryParam);        
        }        
	},
    created() {        
    }
}
</script>
<style lang="scss" scoped>
.CForminline {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    > .form-group {
        margin-bottom: 0;
    }

    > .fluid {
        display: flex;
        align-items: center;

        > .search-fluid {
            display: flex;
            align-items: center;
            margin: .5rem 1rem;
            margin-left: 0;
            // width: 500px;

            > p {
                margin-right: 1rem;
                margin-bottom: 0;
            }
            > .purchase_input {
                margin-bottom: 0;
            }
            > input {
                flex: 1;
                margin: 0 .5rem;
            }
            > div {
                margin: 0 .5rem;
            }
        }
    }
}

.purchase {
    width: 100%;
}

.btn-edit {
    background-color: #343b55;
    color: white;
}
</style>
